module.exports = __webpack_public_path__ + "assets/img/jianjie.389b1d7c.png";